
import { requiredRule } from '@/helpers/validation/requiredRule';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PriceInput from '../PriceInput.vue';
import RegularContainer from './containers/RegularContainer.vue';

@Component({
    components: {
        RegularContainer,
        PriceInput,
    },
})
export default class RegularPriced extends Vue {
    @Prop({ type: String, required: true })
    label!: string;

    @Prop({ type: String, default: '' })
    description!: string;

    @Prop({ type: Number })
    value!: number | null;

    currentValue: number | null = null;
    priceRules = [requiredRule];

    created() {
        this.currentValue = this.value;
    }

    @Watch('currentValue', { deep: true })
    onCurrentValueChange() {
        this.$emit('input', this.currentValue);
    }
}
